import { lazy } from 'react';

export function getRoute(id) {
  switch (id) {
    /* Upgrade Reprice Portlets portlets */
    case 'upgradedashboard':
      return {
        id: 'upgradedashboard',
        package: '@o2-portlets/upgrade-dashboard',
        group: 'upgrade-reprice-portlets',
        directory: 'upgrade-dashboard',
        component: lazy(() =>
          import('@o2-portlets/upgrade-dashboard').then((module) => ({
            default: module.UpgradeDashboardPortlet
          }))
        )
      };
    case 'upgradereprice':
      return {
        id: 'upgradereprice',
        package: '@o2-portlets/upgrade-reprice',
        group: 'upgrade-reprice-portlets',
        directory: 'upgrade-reprice',
        component: lazy(() =>
          import('@o2-portlets/upgrade-reprice').then((module) => ({
            default: module.UpgradeRepricePortlet
          }))
        )
      };
    /* Account portlets */
    case 'accountchangelogin':
      return {
        id: 'accountchangelogin',
        package: '@o2-portlets/account-change-login',
        group: 'account-portlets',
        directory: 'change-login',
        component: lazy(() =>
          import('@o2-portlets/account-change-login').then((module) => ({
            default: module.ChangeLoginPortlet
          }))
        )
      };
    case 'accountchangepassword':
      return {
        id: 'accountchangepassword',
        package: '@o2-portlets/account-change-password',
        group: 'account-portlets',
        directory: 'change-password',
        component: lazy(() =>
          import('@o2-portlets/account-change-password').then((module) => ({
            default: module.ChangePasswordPortlet
          }))
        )
      };
    case 'accountregenerateregistrationcode':
      return {
        id: 'accountregenerateregistrationcode',
        package: '@o2-portlets/account-regenerate-registration-code',
        group: 'account-portlets',
        directory: 'regenerate-registration-code',
        component: lazy(() =>
          import('@o2-portlets/account-regenerate-registration-code').then((module) => ({
            default: module.RegenerateRegistrationCodePortlet
          }))
        )
      };
    /* Admin portlets */
    case 'organizationdetail':
      return {
        id: 'organizationdetail',
        package: '@o2-portlets/organization-detail',
        group: 'admin-portlets',
        directory: 'organization-detail',
        component: lazy(() =>
          import('@o2-portlets/organization-detail').then((module) => ({
            default: module.OrganizationDetailPortlet
          }))
        )
      };
    case 'organizationlist':
      return {
        id: 'organizationlist',
        package: '@o2-portlets/organization-list',
        group: 'admin-portlets',
        directory: 'organization-list',
        component: lazy(() =>
          import('@o2-portlets/organization-list').then((module) => ({
            default: module.OrganizationListPortlet
          }))
        )
      };
    case 'partnerdetail':
      return {
        id: 'partnerdetail',
        package: '@o2-portlets/partner-detail',
        group: 'admin-portlets',
        directory: 'partner-detail',
        component: lazy(() =>
          import('@o2-portlets/partner-detail').then((module) => ({
            default: module.PartnerDetailPortlet
          }))
        )
      };
    case 'partnerlist':
      return {
        id: 'partnerlist',
        package: '@o2-portlets/partner-list',
        group: 'admin-portlets',
        directory: 'partner-list',
        component: lazy(() =>
          import('@o2-portlets/partner-list').then((module) => ({
            default: module.PartnerListPortlet
          }))
        )
      };
    case 'stockdetail':
      return {
        id: 'stockdetail',
        package: '@o2-portlets/stock-detail',
        group: 'admin-portlets',
        directory: 'stock-detail',
        component: lazy(() =>
          import('@o2-portlets/stock-detail').then((module) => ({
            default: module.StockDetailPortlet
          }))
        )
      };
    case 'stocklisting':
      return {
        id: 'stocklisting',
        package: '@o2-portlets/stock-listing',
        group: 'admin-portlets',
        directory: 'stock-listing',
        component: lazy(() =>
          import('@o2-portlets/stock-listing').then((module) => ({
            default: module.StockListingPortlet
          }))
        )
      };
    case 'userdetail':
      return {
        id: 'userdetail',
        package: '@o2-portlets/user-detail',
        group: 'admin-portlets',
        directory: 'user-detail',
        component: lazy(() =>
          import('@o2-portlets/user-detail').then((module) => ({
            default: module.UserDetailPortlet
          }))
        )
      };
    case 'userlist':
      return {
        id: 'userlist',
        package: '@o2-portlets/user-list',
        group: 'admin-portlets',
        directory: 'user-list',
        component: lazy(() =>
          import('@o2-portlets/user-list').then((module) => ({
            default: module.UserListPortlet
          }))
        )
      };
    /* Assistant portlets */
    case 'alternatelogin':
      return {
        id: 'alternatelogin',
        package: '@o2-portlets/alternate-login',
        group: 'assistant-portlets',
        directory: 'alternate-login',
        component: lazy(() =>
          import('@o2-portlets/alternate-login').then((module) => ({
            default: module.AlternateLoginPortlet
          }))
        )
      };
    case 'assistanthouseholding':
      return {
        id: 'assistanthouseholding',
        package: '@o2-portlets/assistant-house-holding',
        group: 'assistant-portlets',
        directory: 'house-holding',
        component: lazy(() =>
          import('@o2-portlets/assistant-house-holding').then((module) => ({
            default: module.HouseHoldingPortlet
          }))
        )
      };
    case 'assistantsubscriberservice':
      return {
        id: 'assistantsubscriberservice',
        package: '@o2-portlets/assistant-subscriber-service',
        group: 'assistant-portlets',
        directory: 'subscriber-service',
        component: lazy(() =>
          import('@o2-portlets/assistant-subscriber-service').then((module) => ({
            default: module.AssistantSubscriberServicePortlet
          }))
        )
      };
    case 'assistantinteractions':
      return {
        id: 'assistantinteractions',
        package: '@o2-portlets/assistant-interactions',
        group: 'assistant-portlets',
        directory: 'assistant-interactions',
        component: lazy(() =>
          import('@o2-portlets/assistant-interactions').then((module) => ({
            default: module.InteractionsPortlet
          }))
        )
      };
    case 'communicationhub':
      return {
        id: 'communicationhub',
        package: '@o2-portlets/communication-hub',
        group: 'assistant-portlets',
        directory: 'communication-hub',
        component: lazy(() =>
          import('@o2-portlets/communication-hub').then((module) => ({
            default: module.CommunicationHubPortlet
          }))
        )
      };
    case 'communicationhubnew':
      return {
        id: 'communicationhubnew',
        package: '@o2-portlets/communication-hub-new',
        group: 'assistant-portlets',
        directory: 'communication-hub-new',
        component: lazy(() =>
          import('@o2-portlets/communication-hub-new').then((module) => ({
            default: module.CommunicationHubNewPortlet
          }))
        )
      };
    case 'createfaprofile':
      return {
        id: 'createfaprofile',
        package: '@o2-portlets/create-fa-profile',
        group: 'assistant-portlets',
        directory: 'create-fa-profile',
        component: lazy(() =>
          import('@o2-portlets/create-fa-profile').then((module) => ({
            default: module.CreateFaProfilePortlet
          }))
        )
      };
    case 'customerobjection':
      return {
        id: 'customerobjection',
        package: '@o2-portlets/customer-objection',
        group: 'assistant-portlets',
        directory: 'customer-objection',
        component: lazy(() =>
          import('@o2-portlets/customer-objection').then((module) => ({
            default: module.CustomerObjectionPortlet
          }))
        )
      };
    case 'digistudent':
      return {
        id: 'digistudent',
        package: '@o2-portlets/digi-student',
        group: 'assistant-portlets',
        directory: 'digi-student',
        component: lazy(() =>
          import('@o2-portlets/digi-student').then((module) => ({
            default: module.DigiStudentPortlet
          }))
        )
      };
    case 'hardwarevoucherexchange':
      return {
        id: 'hardwarevoucherexchange',
        package: '@o2-portlets/hardware-voucher-exchange',
        group: 'assistant-portlets',
        directory: 'hardware-voucher-exchange',
        component: lazy(() =>
          import('@o2-portlets/hardware-voucher-exchange').then((module) => ({
            default: module.HardwareVoucherExchangePortlet
          }))
        )
      };
    case 'headermenu':
      return {
        id: 'headermenu',
        package: '@o2-portlets/header-menu',
        group: 'assistant-portlets',
        directory: 'header-menu',
        component: lazy(() =>
          import('@o2-portlets/header-menu').then((module) => ({
            default: module.HeaderMenuPortlet
          }))
        )
      };
    case 'leadmanagement':
      return {
        id: 'leadmanagement',
        package: '@o2-portlets/lead-management',
        group: 'assistant-portlets',
        directory: 'lead-management',
        component: lazy(() =>
          import('@o2-portlets/lead-management').then((module) => ({
            default: module.LeadManagementPortlet
          }))
        )
      };
    case 'reactivatevoucher':
      return {
        id: 'reactivatevoucher',
        package: '@o2-portlets/reactivate-voucher',
        group: 'assistant-portlets',
        directory: 'reactivate-voucher',
        component: lazy(() =>
          import('@o2-portlets/reactivate-voucher').then((module) => ({
            default: module.ReactivateVoucherPortlet
          }))
        )
      };
    case 'storedockbar':
      return {
        id: 'storedockbar',
        package: '@o2-portlets/store-dockbar',
        group: 'assistant-portlets',
        directory: 'store-dockbar',
        component: lazy(() =>
          import('@o2-portlets/store-dockbar').then((module) => ({
            default: module.StoreDockbarPortlet
          }))
        )
      };
    case 'storepicker':
      return {
        id: 'storepicker',
        package: '@o2-portlets/store-picker',
        group: 'assistant-portlets',
        directory: 'store-picker',
        component: lazy(() =>
          import('@o2-portlets/store-picker').then((module) => ({
            default: module.StorePickerPortlet
          }))
        )
      };
    case 'storesidebar':
      return {
        id: 'storesidebar',
        package: '@o2-portlets/store-sidebar',
        group: 'assistant-portlets',
        directory: 'store-sidebar',
        component: lazy(() =>
          import('@o2-portlets/store-sidebar').then((module) => ({
            default: module.StoreSidebarPortlet
          }))
        )
      };
    case 'threesixty':
      return {
        id: 'threesixty',
        package: '@o2-portlets/three-sixty',
        group: 'assistant-portlets',
        directory: 'three-sixty',
        component: lazy(() =>
          import('@o2-portlets/three-sixty').then((module) => ({
            default: module.ThreeSixtyPortlet
          }))
        )
      };
    /* Checker 5G portlets */
    case 'checker5g':
      return {
        id: 'checker5g',
        package: '@o2-portlets/checker-5g',
        group: 'checker-5g-portlets',
        directory: 'checker-5g',
        component: lazy(() =>
          import('@o2-portlets/checker-5g').then((module) => ({
            default: module.Checker5gPortlet
          }))
        )
      };
    /* CMM portlets */
    case 'cmmlov':
      return {
        id: 'cmmlov',
        package: '@o2-portlets/cmm-lov',
        group: 'cmm-portlets',
        directory: 'cmm-lov',
        component: lazy(() =>
          import('@o2-portlets/cmm-lov').then((module) => ({
            default: module.CmmLovPortlet
          }))
        )
      };
    /* Consumption portlets */
    case 'calllist':
      return {
        id: 'calllist',
        package: '@o2-portlets/call-list',
        group: 'consumption-portlets',
        directory: 'call-list',
        component: lazy(() =>
          import('@o2-portlets/call-list').then((module) => ({
            default: module.CallListPortlet
          }))
        )
      };
    /* CustomerProfileManagement portlets */
    case 'customerprofilemanagement':
      return {
        id: 'customerprofilemanagement',
        package: '@o2-portlets/customer-profile-management',
        group: 'customer-profile-management-portlets',
        directory: 'customer-profile-management',
        component: lazy(() =>
          import('@o2-portlets/customer-profile-management').then((module) => ({
            default: module.CustomerProfileManegementPortlet
          }))
        )
      };
    case 'deviceswithinstallments':
      return {
        id: 'deviceswithinstallments',
        package: '@o2-portlets/devices-with-installments',
        group: 'customer-profile-management-portlets',
        directory: 'devices-with-installments',
        component: lazy(() =>
          import('@o2-portlets/devices-with-installments').then((module) => ({
            default: module.DevicesWithInstallmentsPortlet
          }))
        )
      };
    case 'subscriberprofilemanagement':
      return {
        id: 'subscriberprofilemanagement',
        package: '@o2-portlets/subscriber-profile-management',
        group: 'customer-profile-management-portlets',
        directory: 'subscriber-profile-management',
        component: lazy(() =>
          import('@o2-portlets/subscriber-profile-management').then((module) => ({
            default: module.SubscriberProfileManagementPortlet
          }))
        )
      };
    /* Document archiving portlets */
    case 'documentarchivation':
      return {
        id: 'documentarchivation',
        package: '@o2-portlets/document-archivation',
        group: 'document-archiving-portlets',
        directory: 'document-archivation',
        component: lazy(() =>
          import('@o2-portlets/document-archivation').then((module) => ({
            default: module.DocumentArchivationPortlet
          }))
        )
      };
    case 'documentreceive':
      return {
        id: 'documentreceive',
        package: '@o2-portlets/document-receive',
        group: 'document-archiving-portlets',
        directory: 'document-receive',
        component: lazy(() =>
          import('@o2-portlets/document-receive').then((module) => ({
            default: module.DocumentReceivePortlet
          }))
        )
      };
    case 'documentregistration':
      return {
        id: 'documentregistration',
        package: '@o2-portlets/document-registration',
        group: 'document-archiving-portlets',
        directory: 'document-registration',
        component: lazy(() =>
          import('@o2-portlets/document-registration').then((module) => ({
            default: module.DocumentRegistrationPortlet
          }))
        )
      };
    case 'documentshipment':
      return {
        id: 'documentshipment',
        package: '@o2-portlets/document-shipment',
        group: 'document-archiving-portlets',
        directory: 'document-shipment',
        component: lazy(() =>
          import('@o2-portlets/document-shipment').then((module) => ({
            default: module.DocumentShipmentPortlet
          }))
        )
      };
    /* Eshop portlets */
    case 'eshopcart':
      return {
        id: 'eshopcart',
        package: '@o2-portlets/eshop-cart',
        group: 'eshop-portlets',
        directory: 'eshop-cart',
        component: lazy(() =>
          import('@o2-portlets/eshop-cart').then((module) => ({
            default: module.EshopCartPortlet
          }))
        )
      };
    case 'eshopcheckout':
      return {
        id: 'eshopcheckout',
        package: '@o2-portlets/eshop-checkout',
        group: 'eshop-portlets',
        directory: 'eshop-checkout',
        component: lazy(() =>
          import('@o2-portlets/eshop-checkout').then((module) => ({
            default: module.EshopCheckoutPortlet
          }))
        )
      };
    case 'eshophardware':
      return {
        id: 'eshophardware',
        package: '@o2-portlets/eshop-hardware',
        group: 'eshop-portlets',
        directory: 'eshop-hardware',
        component: lazy(() =>
          import('@o2-portlets/eshop-hardware').then((module) => ({
            default: module.EshopHardwarePortlet
          }))
        )
      };
    case 'eshophardwarecompare':
      return {
        id: 'eshophardwarecompare',
        package: '@o2-portlets/eshop-hardware-compare',
        group: 'eshop-portlets',
        directory: 'eshop-hardware-compare',
        component: lazy(() =>
          import('@o2-portlets/eshop-hardware-compare').then((module) => ({
            default: module.EshopHardwareComparePortlet
          }))
        )
      };
    case 'eshopwizard':
      return {
        id: 'eshopwizard',
        package: '@o2-portlets/eshop-wizard',
        group: 'eshop-portlets',
        directory: 'eshop-wizard',
        component: lazy(() =>
          import('@o2-portlets/eshop-wizard').then((module) => ({
            default: module.EshopWizardPortlet
          }))
        )
      };
    /* Fix portlets */
    case 'fixchangetariff':
      return {
        id: 'fixchangetariff',
        package: '@o2-portlets/fix-change-tariff',
        group: 'fix-portlets',
        directory: 'fix-change-tariff',
        component: lazy(() =>
          import('@o2-portlets/fix-change-tariff').then((module) => ({
            default: module.FixChangeTariffPortlet
          }))
        )
      };
    /* Insurance portlets */
    case 'o2insurance':
      return {
        id: 'o2insurance',
        package: '@o2-portlets/o2-insurance',
        group: 'insurance-portlets',
        directory: 'o2-insurance',
        component: lazy(() =>
          import('@o2-portlets/o2-insurance').then((module) => ({
            default: module.O2InsurancePortlet
          }))
        )
      };
    case 'o2insuranceactivation':
      return {
        id: 'o2insuranceactivation',
        package: '@o2-portlets/o2-insurance-activation',
        group: 'insurance-portlets',
        directory: 'o2-insurance-activation',
        component: lazy(() =>
          import('@o2-portlets/o2-insurance-activation').then((module) => ({
            default: module.O2InsuranceActivationPortlet
          }))
        )
      };
    case 'o2insuranceupdate':
      return {
        id: 'o2insuranceupdate',
        package: '@o2-portlets/o2-insurance-update',
        group: 'insurance-portlets',
        directory: 'o2-insurance-update',
        component: lazy(() =>
          import('@o2-portlets/o2-insurance-update').then((module) => ({
            default: module.O2InsuranceUpdatePortlet
          }))
        )
      };
    /* OPE portlets */
    case 'digitalboxdashboard':
      return {
        id: 'digitalboxdashboard',
        package: '@o2-portlets/digital-box-dashboard',
        group: 'ope-portlets',
        directory: 'digital-box',
        component: lazy(() =>
          import('@o2-portlets/digital-box-dashboard').then((module) => ({
            default: module.DigitalBoxPortlet
          }))
        )
      };
    case 'paymentadmin':
      return {
        id: 'paymentadmin',
        package: '@o2-portlets/payment-admin',
        group: 'ope-portlets',
        directory: 'payment-admin',
        component: lazy(() =>
          import('@o2-portlets/payment-admin').then((module) => ({
            default: module.PaymentAdminPortlet
          }))
        )
      };
    case 'rechargingadmin':
      return {
        id: 'rechargingadmin',
        package: '@o2-portlets/recharging-admin',
        group: 'ope-portlets',
        directory: 'recharging-admin',
        component: lazy(() =>
          import('@o2-portlets/recharging-admin').then((module) => ({
            default: module.RechargingAdminPortlet
          }))
        )
      };
    case 'recharginghistory':
      return {
        id: 'recharginghistory',
        package: '@o2-portlets/recharging-history',
        group: 'ope-portlets',
        directory: 'recharging-history',
        component: lazy(() =>
          import('@o2-portlets/recharging-history').then((module) => ({
            default: module.RechargingHistoryPortlet
          }))
        )
      };
    /* Order Management portlets */
    case 'orderdetail':
      return {
        id: 'orderdetail',
        package: '@o2-portlets/order-detail',
        group: 'order-management-portlets',
        directory: 'order-detail',
        component: lazy(() =>
          import('@o2-portlets/order-detail').then((module) => ({
            default: module.OrderDetailPortlet
          }))
        )
      };
    case 'orderthankyou':
      return {
        id: 'orderthankyou',
        package: '@o2-portlets/order-thank-you',
        group: 'order-management-portlets',
        directory: 'thank-you',
        component: lazy(() =>
          import('@o2-portlets/order-thank-you').then((module) => ({
            default: module.ThankYouPortlet
          }))
        )
      };
    /* PCE portlets */
    case 'pceadmin':
      return {
        id: 'pceadmin',
        package: '@o2-portlets/pce-admin',
        group: 'pce-portlets',
        directory: 'pce-admin',
        component: lazy(() =>
          import('@o2-portlets/pce-admin').then((module) => ({
            default: module.PceAdminPortlet
          }))
        )
      };
    /* Radost portlets */
    case 'assistedradostactivation':
      return {
        id: 'assistedradostactivation',
        package: '@o2-portlets/assisted-radost-activation',
        group: 'radost-portlets',
        directory: 'assisted-activation',
        component: lazy(() =>
          import('@o2-portlets/assisted-radost-activation').then((module) => ({
            default: module.AssistedRadostActivationPortlet
          }))
        )
      };
    /* Security portlets */
    case 'cvccodesettings':
      return {
        id: 'cvccodesettings',
        package: '@o2-portlets/cvc-code-settings',
        group: 'security-portlets',
        directory: 'cvc-code-settings',
        component: lazy(() =>
          import('@o2-portlets/cvc-code-settings').then((module) => ({
            default: module.CvcCodeSettingsPortlet
          }))
        )
      };
    case 'o2security':
      return {
        id: 'o2security',
        package: '@o2-portlets/o2-security',
        group: 'security-portlets',
        directory: 'o2-security',
        component: lazy(() =>
          import('@o2-portlets/o2-security').then((module) => ({
            default: module.O2SecurityPortlet
          }))
        )
      };
    /* Selfcare portlets */
    case 'billingprofilemanagement':
      return {
        id: 'billingprofilemanagement',
        package: '@o2-portlets/billing-profile-management',
        group: 'selfcare-portlets',
        directory: 'billing-profile-management',
        component: lazy(() =>
          import('@o2-portlets/billing-profile-management').then((module) => ({
            default: module.BillingProfileManagementPortlet
          }))
        )
      };
    case 'ltesimcardcheck':
      return {
        id: 'ltesimcardcheck',
        package: '@o2-portlets/lte-sim-card-check',
        group: 'selfcare-portlets',
        directory: 'lte-sim-card-check',
        component: lazy(() =>
          import('@o2-portlets/lte-sim-card-check').then((module) => ({
            default: module.LteSimCardCheckPortlet
          }))
        )
      };
    case 'mcceligibility':
      return {
        id: 'mcceligibility',
        package: '@o2-portlets/mcc-eligibility',
        group: 'selfcare-portlets',
        directory: 'mcc-eligibility',
        component: lazy(() =>
          import('@o2-portlets/mcc-eligibility').then((module) => ({
            default: module.MccEligibilityPortlet
          }))
        )
      };
    case 'prepaidactivation':
      return {
        id: 'prepaidactivation',
        package: '@o2-portlets/prepaid-activation',
        group: 'selfcare-portlets',
        directory: 'prepaid-activation',
        component: lazy(() =>
          import('@o2-portlets/prepaid-activation').then((module) => ({
            default: module.PrepaidActivationPortlet
          }))
        )
      };
    case 'salesassistant':
      return {
        id: 'salesassistant',
        package: '@o2-portlets/sales-assistant',
        group: 'selfcare-portlets',
        directory: 'sales-assistant',
        component: lazy(() =>
          import('@o2-portlets/sales-assistant').then((module) => ({
            default: module.SalesAssistantPortlet
          }))
        )
      };
    case 'subscriberunsuspend':
      return {
        id: 'subscriberunsuspend',
        package: '@o2-portlets/subscriber-unsuspend',
        group: 'selfcare-portlets',
        directory: 'subscriber-unsuspend',
        component: lazy(() =>
          import('@o2-portlets/subscriber-unsuspend').then((module) => ({
            default: module.SubscriberUnsuspendPortlet
          }))
        )
      };
    case 'trusteddeviceslist':
      return {
        id: 'trusteddeviceslist',
        package: '@o2-portlets/trusted-devices-list',
        group: 'selfcare-portlets',
        directory: 'trusted-devices-list',
        component: lazy(() =>
          import('@o2-portlets/trusted-devices-list').then((module) => ({
            default: module.TrustedDevicesListPortlet
          }))
        )
      };
    case 'zekdocuments':
      return {
        id: 'zekdocuments',
        package: '@o2-portlets/zek-documents',
        group: 'selfcare-portlets',
        directory: 'zek-documents',
        component: lazy(() =>
          import('@o2-portlets/zek-documents').then((module) => ({
            default: module.ZekDocumentsPortlet
          }))
        )
      };
    /* Smart ID portlets */
    case 'cancelsmartid':
      return {
        id: 'cancelsmartid',
        package: '@o2-portlets/cancel-smart-id',
        group: 'smart-id-portlets',
        directory: 'cancel-smart-id',
        component: lazy(() =>
          import('@o2-portlets/cancel-smart-id').then((module) => ({
            default: module.CancelSmartIdPortlet
          }))
        )
      };
    case 'replacesmartid':
      return {
        id: 'replacesmartid',
        package: '@o2-portlets/replace-smart-id',
        group: 'smart-id-portlets',
        directory: 'replace-smart-id',
        component: lazy(() =>
          import('@o2-portlets/replace-smart-id').then((module) => ({
            default: module.ReplaceSmartIDPortlet
          }))
        )
      };
    /* Ticketing portlets */
    case 'internalfinancingcustomer':
      return {
        id: 'internalfinancingcustomer',
        package: '@o2-portlets/internal-financing-customer',
        group: 'ticketing-portlets',
        directory: 'internal-financing-customer',
        component: lazy(() =>
          import('@o2-portlets/internal-financing-customer').then((module) => ({
            default: module.InternalFinancingCustomerPortlet
          }))
        )
      };
    case 'internalfinancingdetail':
      return {
        id: 'internalfinancingdetail',
        package: '@o2-portlets/internal-financing-detail',
        group: 'ticketing-portlets',
        directory: 'internal-financing-detail',
        component: lazy(() =>
          import('@o2-portlets/internal-financing-detail').then((module) => ({
            default: module.InternalFinancingDetailPortlet
          }))
        )
      };
    case 'internalfinancinglist':
      return {
        id: 'internalfinancinglist',
        package: '@o2-portlets/internal-financing-list',
        group: 'ticketing-portlets',
        directory: 'internal-financing-list',
        component: lazy(() =>
          import('@o2-portlets/internal-financing-list').then((module) => ({
            default: module.InternalFinancingListPortlet
          }))
        )
      };
  }
}
